/** @format */

// GET_USER
export const GET_SELLER_REQUEST = "GET_SELLER_REQUEST";

// ACCEPT_SELLER_REQUEST
export const ACCEPT_SELLER_REQUEST = "ACCEPT_SELLER_REQUEST";

// REJECT_SELLER_REQUEST
export const REJECT_SELLER_REQUEST = "REJECT_SELLER_REQUEST";

// EDIT_SELLER_REQUEST
export const UPDATE_SELLER_REQUEST = "UPDATE_SELLER_REQUEST";
